import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import { AuthService } from "../services/authService";

let API_BASE_URL = "http://localhost:8000/api/admin"
let AGENT_API_BASE_URL = "http://localhost:8001/api"

if (process.env.NODE_ENV == 'production') {
    API_BASE_URL = 'https://api.mart-24.com/api/admin';
    AGENT_API_BASE_URL = 'https://agent.mart-24.com/api';
}


const createAxiosInstance = (config: AxiosRequestConfig): AxiosInstance => {
    const instance = axios.create({
        baseURL: API_BASE_URL,
        ...config
    });

    instance.interceptors.request.use(
        async (config) => {
            // Skip authentication for OTP endpoints
            const publicEndpoints = ['/send-otp', '/verify-otp'];
            const isPublicEndpoint = publicEndpoints.some(endpoint =>
                config.url?.includes(endpoint)
            );

            if (!isPublicEndpoint) {
                const token = await AuthService.getIdToken();
                //console.log(token);
                if (token) {
                    config.headers['Authorization'] = `Bearer ${token}`;
                }
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    return instance;
};

const createAgentAxiosInstance = (config: AxiosRequestConfig): AxiosInstance => {
    const instance = axios.create({
        baseURL: AGENT_API_BASE_URL,
        ...config
    });

    instance.interceptors.request.use(
        async (config) => {
            // Skip authentication for OTP endpoints
            const publicEndpoints = ['/send-otp', '/verify-otp'];
            const isPublicEndpoint = publicEndpoints.some(endpoint =>
                config.url?.includes(endpoint)
            );

            if (!isPublicEndpoint) {
                const token = await AuthService.getIdToken();
                //console.log(token);
                if (token) {
                    config.headers['Authorization'] = `Bearer ${token}`;
                }
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    return instance;
};



export const axiosInstance = createAxiosInstance({
    headers: {
        'Content-Type': 'application/json',
    }
});

export const axiosMultipartInstance = createAxiosInstance({
    headers: {
        'Content-Type': 'multipart/form-data',
    }
});

// Agent-specific axios instances
export const agentAxiosInstance = createAgentAxiosInstance({
    headers: {
        'Content-Type': 'application/json',
    }
});

export const agentAxiosMultipartInstance = createAgentAxiosInstance({
    headers: {
        'Content-Type': 'multipart/form-data',
    }
});

export default axiosInstance;
